import React from "react";
import _ from 'lodash';
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import ExternalLink from "UI/Heroicons/ExternalLink";
import Container from "Components/Container";
import Heading from "UI/Heading";
import {Tab, Tabs} from "UI/Tabs";
import {Link} from "react-router-dom";
import PostSkeleton from "Components/Skeletons/PostSkeleton";
import PostList from "Components/PostList";
import BlankPosts from "Components/BlankStates/BlankPosts";

export class SharingController extends React.Component {
    static propTypes = {
        posts: PropTypes.array.isRequired,
        integrations: PropTypes.object.isRequired,

        status: PropTypes.string
    };

    static defaultProps = {
        status: 'scheduled'
    };

    render() {
        const {status, counts, posts} = this.props;

        const title = <div className='flex'>
            <ExternalLink className='w-7 mr-3'/>Sharing
        </div>;

        return <Container>

            <Heading
                title={title}
                description='Stories you are sharing with your audience'
            />

            <Tabs>
                <Tab component={Link} to='/sharing' active={status === 'scheduled'}>
                    Scheduled{this.renderCount(counts.scheduled)}
                </Tab>
                <Tab component={Link} to='/sharing?status=shared' active={status === 'shared'}>
                    Shared{this.renderCount(counts.shared)}
                </Tab>
                <Tab component={Link} to='/sharing?status=draft' active={status === 'draft'}>
                    Drafts{this.renderCount(counts.draft)}
                </Tab>
            </Tabs>

            {
                this.props.loading &&
                <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6'>
                    <PostSkeleton/>
                </div>
            }

            <PostList
                posts={this.props.posts}
                integrations={this.props.integrations}
                status={this.props.status}
            />

            {!this.props.loading && this.renderBlankState()}
        </Container>;
    }

    renderCount(number) {
        if (number < 1) {
            return;
        }

        return ` (${number})`;
    }

    renderBlankState() {
        if (this.props.posts.length > 0) {
            return null;
        }

        return <BlankPosts/>;
    }
}

const mapStateToProps = (state, ownProps) => ({
    accountId: state.currentAccountId,
    posts: _.filter(state.posts, post => post.account_id === state.currentAccountId && post.status === (ownProps.status || 'scheduled')),
    integrations: state.integrations,
    counts: {
        scheduled: _.filter(state.posts, post => post.status === 'scheduled').length,
        shared: _.filter(state.posts, post => post.status === 'shared' || post.status === 'sharing').length,
        draft: _.filter(state.posts, post => post.status === 'draft').length,
    }
});

export default connect(mapStateToProps)(SharingController);
